import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { createConnectOnboardingLink } from '@/lib/lendliftedService';

export default function OnboardingPage() {
  const { userSettings } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const workspaceId = userSettings?.activeWorkspaceId;

  const startOnboarding = async () => {
    if (!workspaceId) {
      toast.error('No active workspace found.');
      return;
    }

    setIsLoading(true);
    try {
      const response = await createConnectOnboardingLink({
        workspaceId,
        refreshUrl: `${window.location.origin}/onboarding`,
        returnUrl: `${window.location.origin}/studio`,
      });
      window.location.assign(response.onboardingUrl);
    } catch (error) {
      console.error('Failed to create onboarding link', error);
      toast.error('Could not start onboarding. Please try again.');
      setIsLoading(false);
    }
  };

  return (
    <section className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
      <div className="rounded-3xl border border-slate-900/10 bg-white/90 p-8">
        <h1 className="font-[Sora] text-3xl text-slate-900">Stripe Connect onboarding</h1>
        <p className="mt-3 text-slate-700">
          Start in a few minutes. You can sell immediately and finalize payout details before your first cashout.
        </p>
        <Button onClick={startOnboarding} disabled={isLoading} className="mt-6">
          {isLoading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
          Continue setup
        </Button>
      </div>
    </section>
  );
}
